import { Link } from "react-router-dom";
import { CORPORATE_NEWS } from "../CorporatePortalContent";

export default function CorporateNewsPage() {
  return (
    <>
      <section className="corporate-page-banner">
        <div className="corporate-page-banner-inner">
          <h1 className="corporate-page-banner-title">新闻动态</h1>
          <p className="corporate-page-banner-desc">了解公司产品发布、合作动态与行业活动。</p>
        </div>
      </section>

      <div className="corporate-page">
        <section className="corporate-section" style={{ paddingTop: 40 }}>
          <div className="corporate-news-list">
            {CORPORATE_NEWS.map((item) => (
              <Link key={item.id} to={`/news/${item.id}`} className="corporate-news-item">
                <div className="corporate-news-meta">
                  <span>{item.date}</span>
                  <span>{item.category}</span>
                </div>
                <h3 className="corporate-news-title">{item.title}</h3>
                <p className="corporate-news-summary">{item.summary}</p>
              </Link>
            ))}
          </div>
        </section>
      </div>
    </>
  );
}
